import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Button, Divider, Modal, Typography } from "@mui/material";

import { getServicePageRoute } from "../../../../routers/routeUtils";

import ServiceCreatedSuccessfullyFigure from "../../assets/images/horray-success-figure.png";
import { ServiceTypeEnum } from "../../enum/service.enum";

const ServiceCreatedPopUp = ({
  serviceCreatedState: { serviceCreated, serviceId, serviceType },
  closeModal,
}: {
  serviceCreatedState: { serviceCreated: boolean; serviceId: string; serviceType: string };
  closeModal: () => void;
}) => {
  const { t } = useTranslation("goService", { keyPrefix: "createServicePage.serviceCreatedPopUp" });

  const navigate = useNavigate();
  const handleCheckNow = () => navigate(getServicePageRoute(serviceId, serviceType));

  return (
    <Modal open={serviceCreated} onClose={closeModal}>
      <Box sx={styles.container}>
        <Box
          component="img"
          src={ServiceCreatedSuccessfullyFigure}
          alt="service-created-successfully"
          sx={styles.figure}
        />
        <Typography sx={styles.title}>
          {serviceType === ServiceTypeEnum.OneTime ? t("horrayService") : t("horrayCourse")}
        </Typography>
        <Typography sx={styles.description}>{t("weVeReceivedYourSubmission")}</Typography>
        <Divider flexItem orientation="horizontal" sx={{ margin: "0 -32px" }} />
        <Box sx={styles.buttonContainer}>
          <Button variant="outlined-md" onClick={closeModal} sx={styles.actionButton}>
            {t("cancel")}
          </Button>
          <Button variant="primary-md" onClick={handleCheckNow} sx={styles.actionButton}>
            {t("checkNow")}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ServiceCreatedPopUp;

const styles = {
  container: {
    width: { xs: "90%", md: "736px" },
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "#FFF",
    borderRadius: "12px ",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "32px",
    padding: "24px 32px",
  },
  figure: {
    width: "157px",
    height: "120px",
  },
  title: {
    fontFamily: "Montserrat",
    color: "var(--Dark---1000, #111)",
    textAlign: "center",
    fontSize: "32px",
    fontStyle: "normal",
    fontWeight: 750,
    lineHeight: "normal",
  },
  description: {
    fontFamily: "Montserrat",
    color: "var(--Dark---800, #414141)",
    textAlign: "center",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
  },
  buttonContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    gap: "16px",
  },
  actionButton: {
    width: "fit-content",
  },
};
